module.exports = __webpack_public_path__ + "static/media/Life-navy-blue.09928652.svg";